import { default as TextSnippetOutlinedIcon } from '@mui/icons-material/TextSnippetOutlined';
import { CenterPositionedRow } from 'components/flex-containers';
import { SmallLightLabel } from 'components/labels';
import { AssignmentChange } from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import {
  ASSIGNMENT_CHANGE_STATUS_MAP,
  StatusBadge
} from 'modules/status-badge';
import { DEFAULT_TIMEZONE, getShortDateLabelWithTimezone } from 'utils/date';
import { MAP_CHANGES_INFO_TEXT, prepareChangeSetData } from '../utils';
import { ChangeSetItem } from './ChangeSetItem';
import { ContentBox, InfoTextWrapper, Wrapper } from './styledComponents';

export const ChangeItem = ({
  changeData
}: {
  changeData: AssignmentChange;
}) => {
  const { changeSet } = changeData;

  if (!changeSet) return null;

  const readyChangeSetData = prepareChangeSetData(changeSet);

  const getInfoText = () => {
    const infoText = MAP_CHANGES_INFO_TEXT[changeData.status];
    return `${getTrans(infoText ?? '')}
    ${getShortDateLabelWithTimezone(changeData.appliedAt, DEFAULT_TIMEZONE)}`;
  };

  return (
    <Wrapper>
      <ContentBox>
        <CenterPositionedRow>
          <StatusBadge
            status={changeData.status}
            statusMap={ASSIGNMENT_CHANGE_STATUS_MAP}
          />
        </CenterPositionedRow>
        <InfoTextWrapper>
          <TextSnippetOutlinedIcon />
          <SmallLightLabel variant="body2">{getInfoText()}</SmallLightLabel>
        </InfoTextWrapper>
        {readyChangeSetData.map(item => (
          <ChangeSetItem key={item.label} item={item} />
        ))}
      </ContentBox>
    </Wrapper>
  );
};
